<h3 [ngClass]="{'black-text': isTextBlack}">{{text}}</h3>